import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const data = {
  itemDetails: null,
  creditCards: [],
  creditCardsLoadingStatus: '',
  creditAccounts: [],
  investmentAccounts: [],
  cryptocurrencyAccounts: [],
  accountsLoadingStatus: '',
  foodAndHousing: {},
  foodAndHousingLoadingStatus: '',
  transportationAndMedical: {},
  transportationAndMedicalLoadingStatus: '',
  otherLivingExpenses: {},
  additionalExpensesFiles: [],
  otherLivingExpensesLoadingStatus: '',
};

export default {
  state: data,
  getters,
  mutations,
  actions,
};
